import TodoItem from "@/domain/entities/TodoItem";
import { TodoItem as MailTodoItem } from "@cs_teamwaydev/mailvista-sdk_react";

const todoMapper = (todo: MailTodoItem, internetMessageId: string): TodoItem =>
    new TodoItem({
        id: todo.id,
        taskSummary: todo.taskSummary,
        linkedEventId: todo.linkedEventId,
        done: todo.done,
        isUserAccepted: todo.isUserAccepted,
        internetMessageId: internetMessageId,
        checkedDate: todo.checkedDate,
    });

export default todoMapper;
